/**
 * Nationality / country options for flights and forms (ISO 3166-1 alpha-2).
 * Merged with GET /api/countries so prod still works if the DB only has Nepal seeded.
 */

/** @type {{ name: string, country_char: string, country_code?: string }[]} */
export const FALLBACK_COUNTRIES = [
	{ name: 'Nepal', country_char: 'NP', country_code: '+977' },
	{ name: 'India', country_char: 'IN', country_code: '+91' },
	{ name: 'United States', country_char: 'US', country_code: '+1' },
	{ name: 'United Kingdom', country_char: 'GB', country_code: '+44' },
	{ name: 'Canada', country_char: 'CA', country_code: '+1' },
	{ name: 'Australia', country_char: 'AU', country_code: '+61' },
	{ name: 'Germany', country_char: 'DE', country_code: '+49' },
	{ name: 'France', country_char: 'FR', country_code: '+33' },
	{ name: 'Netherlands', country_char: 'NL', country_code: '+31' },
	{ name: 'Switzerland', country_char: 'CH', country_code: '+41' },
	{ name: 'Italy', country_char: 'IT', country_code: '+39' },
	{ name: 'Spain', country_char: 'ES', country_code: '+34' },
	{ name: 'Japan', country_char: 'JP', country_code: '+81' },
	{ name: 'China', country_char: 'CN', country_code: '+86' },
	{ name: 'South Korea', country_char: 'KR', country_code: '+82' },
	{ name: 'Singapore', country_char: 'SG', country_code: '+65' },
	{ name: 'Malaysia', country_char: 'MY', country_code: '+60' },
	{ name: 'Thailand', country_char: 'TH', country_code: '+66' },
	{ name: 'Indonesia', country_char: 'ID', country_code: '+62' },
	{ name: 'Philippines', country_char: 'PH', country_code: '+63' },
	{ name: 'Vietnam', country_char: 'VN', country_code: '+84' },
	{ name: 'Bangladesh', country_char: 'BD', country_code: '+880' },
	{ name: 'Pakistan', country_char: 'PK', country_code: '+92' },
	{ name: 'Sri Lanka', country_char: 'LK', country_code: '+94' },
	{ name: 'Bhutan', country_char: 'BT', country_code: '+975' },
	{ name: 'Maldives', country_char: 'MV', country_code: '+960' },
	{ name: 'United Arab Emirates', country_char: 'AE', country_code: '+971' },
	{ name: 'Saudi Arabia', country_char: 'SA', country_code: '+966' },
	{ name: 'Qatar', country_char: 'QA', country_code: '+974' },
	{ name: 'Israel', country_char: 'IL', country_code: '+972' },
	{ name: 'Turkey', country_char: 'TR', country_code: '+90' },
	{ name: 'Russia', country_char: 'RU', country_code: '+7' },
	{ name: 'Brazil', country_char: 'BR', country_code: '+55' },
	{ name: 'Mexico', country_char: 'MX', country_code: '+52' },
	{ name: 'Argentina', country_char: 'AR', country_code: '+54' },
	{ name: 'South Africa', country_char: 'ZA', country_code: '+27' },
	{ name: 'Nigeria', country_char: 'NG', country_code: '+234' },
	{ name: 'Kenya', country_char: 'KE', country_code: '+254' },
	{ name: 'Egypt', country_char: 'EG', country_code: '+20' },
	{ name: 'New Zealand', country_char: 'NZ', country_code: '+64' },
	{ name: 'Ireland', country_char: 'IE', country_code: '+353' },
	{ name: 'Sweden', country_char: 'SE', country_code: '+46' },
	{ name: 'Norway', country_char: 'NO', country_code: '+47' },
	{ name: 'Denmark', country_char: 'DK', country_code: '+45' },
	{ name: 'Finland', country_char: 'FI', country_code: '+358' },
	{ name: 'Belgium', country_char: 'BE', country_code: '+32' },
	{ name: 'Austria', country_char: 'AT', country_code: '+43' },
	{ name: 'Poland', country_char: 'PL', country_code: '+48' },
	{ name: 'Portugal', country_char: 'PT', country_code: '+351' },
	{ name: 'Greece', country_char: 'GR', country_code: '+30' },
	{ name: 'Czech Republic', country_char: 'CZ', country_code: '+420' },
	{ name: 'Hungary', country_char: 'HU', country_code: '+36' },
	{ name: 'Romania', country_char: 'RO', country_code: '+40' },
	{ name: 'Ukraine', country_char: 'UA', country_code: '+380' },
	{ name: 'Hong Kong', country_char: 'HK', country_code: '+852' },
	{ name: 'Taiwan', country_char: 'TW', country_code: '+886' },
];

export function mapApiCountryToOption(country, index = 0) {
	const char = (country.country_char || '').toUpperCase();
	return {
		key: country.id != null ? country.id : char || index,
		value: char,
		flag: char.toLowerCase(),
		text: country.name,
		currency: country.currency_char,
		code: country.country_code,
	};
}

/** Semantic UI dropdown options, merged and sorted by name. */
export function mergeCountriesWithFallback(apiCountries) {
	const byChar = new Map();

	FALLBACK_COUNTRIES.forEach((row, i) => {
		const char = row.country_char.toUpperCase();
		byChar.set(char, mapApiCountryToOption({ ...row, id: `fb-${char}` }, i));
	});

	(apiCountries || []).forEach((country, i) => {
		const char = (country.country_char || '').toUpperCase();
		if (!char) return;
		byChar.set(char, mapApiCountryToOption(country, i));
	});

	return [...byChar.values()].sort((a, b) =>
		String(a.text).localeCompare(String(b.text), undefined, { sensitivity: 'base' })
	);
}
